<template>
  <div class="tag-edit-page scrollable">
    <div class="page-header">
      <h1>{{ $route.meta.title }}</h1>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">
          <i class="mdi mdi-home-outline"></i>
        </el-breadcrumb-item>
        <el-breadcrumb-item :to="{ name: 'tags' }">
          Tag
        </el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="edit-form">
      <el-form
          :model="formData"
          status-icon
          :rules="rulesValidate"
          ref="tagEditForm"
          label-width="135px"
          class="demo-ruleForm"
      >
        <el-form-item label="Name" prop="name">
          <el-input
              type="text"
              v-model="formData.name"
              autocomplete="off"
          ></el-input>
        </el-form-item>

        <el-form-item label="Slug" prop="slug">
          <el-input
              type="textarea"
              v-model="formData.slug"
          ></el-input>
          <button class="go-to-page-button" @click="redirectToLink" style="cursor: pointer;">GO TO PAGE</button>
        </el-form-item>

        <el-form-item label="Description" prop="description">
          <el-input
              type="textarea"
              v-model="formData.description"
              autocomplete="off"
          ></el-input>
        </el-form-item>

        <el-form-item label="SEO Title" prop="seo_title">
          <el-input
              v-model="formData.seo_title"
              placeholder="Enter title for SEO"
          ></el-input>
        </el-form-item>

        <el-form-item label="SEO Description" prop="seo_description">
          <el-input
              type="textarea"
              v-model="formData.seo_description"
              placeholder="Enter description for SEO"
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="submitForm('tagEditForm')"
          >Save
          </el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { Message } from 'element-ui'

export default {
  name: 'TagEdit',
  data () {
    return {
      urlRequest: '',
      formData: {
        id: '',
        name: '',
        seo_title: '',
        seo_description: '',
      },
      rulesValidate: {
        name: [
            {
              required: true,
              message: 'Please input Tag name. Name unique',
              trigger: 'blur'}
        ],
        slug: [
          {
            validator: this.validateSlug,
            trigger: 'blur'
          }
        ],
        seo_title: [
          {required: true, message: 'Please, input seo title!', trigger: 'blur'},
        ],
        seo_description: [
          {required: true, message: 'Please, input seo description!', trigger: 'blur'},
        ],
      },
    }
  },
  computed: {
    ...mapGetters({
      tag: 'tags/getShowTag',
    }),
  },

  created () {
    if (this.$route.params.id) {
      this.$store.dispatch('tags/getShowTag', this.$route.params.id)
    } else {
      this.$store.dispatch('tags/clearCurrentTag')
    }
  },
  watch: {
    tag(newTag) {
      if (newTag) {
        this.formData = newTag
      }
    }
  },
  methods: {
    submitForm (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (!this.$route.params.id) {
            this.$store.dispatch('tags/createTag', this.formData).then((resp) => {
              this.$router.push({name:"tags"})
            })
          } else {
            this.$store.dispatch('tags/updateTag', this.formData)
          }
        } else {
          Message({
            message: 'Form not validated',
            type: 'error',
            duration: 5 * 1000,
          })
          console.log('error submit!!')
          return false
        }
      })
    },
    redirectToLink() {
      window.open(`${process.env.VUE_APP_MAIN_SITE}/blog/tag/${this.formData.slug}`);
    },
    validateSlug(rule, value, callback) {
      const slugPattern = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;
      if (!slugPattern.test(value)) {
        callback(new Error('Slug must be in a valid link format (lowercase, hyphens allowed)'));
      } else {
        callback();
      }
    },
  },
}
</script>